<script lang="ts">
    export let left: boolean = false
</script>
<div class="floating-actions p-1 box-r sx-1 back-white shadow radius"
     class:left={left}>
    <slot>

    </slot>
</div>
<style>
    .floating-actions {
        position: fixed;
        bottom: 0;
        right: 0;
        z-index: 10;
    }

    .floating-actions.left {
        right: auto;
        left: 90px;
    }
</style>
